import { action } from 'satcheljs/lib/legacy';
import { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';
import createOrUpdateOptionsForFeatures from './createOrUpdateOptionsForFeature';
import SurfaceActionsOptions from '../store/schema/options/SurfaceActionsOptions';
import CalendarSurfaceAddinsOptions from '../store/schema/options/CalendarSurfaceAddinsOptions';
import getOptionsForFeature from '../selectors/getOptionsForFeature';
import AddinPinModes from '../utils/AddinPinModes';

export default action('updateAddinPinStatus')(function updateAddinPinStatus(
    productId: string,
    newPinnedStatus: boolean,
    pinOptions: AddinPinModes
) {
    let mailOptions: SurfaceActionsOptions = getOptionsForFeature<SurfaceActionsOptions>(
        OwsOptionsFeatureType.SurfaceActions
    );

    let calendarOptions: CalendarSurfaceAddinsOptions = getOptionsForFeature<
        CalendarSurfaceAddinsOptions
    >(OwsOptionsFeatureType.CalendarSurfaceAddins);

    let callMailApi = pinOptions.readMode
        ? updateOptions(mailOptions.readSurfaceAddins, productId, newPinnedStatus)
        : false;
    callMailApi = pinOptions.composeMode
        ? updateOptions(mailOptions.composeSurfaceAddins, productId, newPinnedStatus) || callMailApi
        : callMailApi;

    let callCalendarApi = pinOptions.calendarMode
        ? updateOptions(calendarOptions.calendarSurfaceAddins, productId, newPinnedStatus)
        : false;

    if (callMailApi) {
        createOrUpdateOptionsForFeatures(OwsOptionsFeatureType.SurfaceActions, mailOptions);
    }
    if (callCalendarApi) {
        createOrUpdateOptionsForFeatures(
            OwsOptionsFeatureType.CalendarSurfaceAddins,
            calendarOptions
        );
    }
});

let updateOptions = (
    addinsArray: Array<string>,
    productId: string,
    newPinnedStatus: boolean
): boolean => {
    let callApi = false;

    if (newPinnedStatus) {
        if (addinsArray.indexOf(productId) === -1) {
            addinsArray.push(productId);
            callApi = true;
        }
    } else {
        if (addinsArray.indexOf(productId) !== -1) {
            addinsArray.splice(addinsArray.indexOf(productId), 1);
            callApi = true;
        }
    }
    return callApi;
};
